import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

export default function GrantDistributionChart({
  activeType,
  filteredResources,
}) {
  const computeTotalsForSubscription = (resources = []) => {
    const totalsMap = {};

    resources.forEach((item) => {
      const key = item.uom;

      if (!totalsMap[key]) {
        totalsMap[key] = {
          uom: item.uom,
          total: 0,
        };
      }

      totalsMap[key].total += item.remainingBalance ?? 0;
    });

    return Object.values(totalsMap);
  };

  const chartSeries = useMemo(() => {
    const totals = computeTotalsForSubscription(filteredResources);

    return totals.map((t, inx, arr) => ({
      name: t.uom,
      data: arr.map((_, idx) => (idx === inx ? t.total : 0)),
      total: t.total,
    }));
  }, [filteredResources]);

  const maxValue = useMemo(() => {
    const max = Math.max(...chartSeries?.map((t) => t.total));
    const buffered = max * 1.2;

    // Get the order of magnitude
    const magnitude = Math.pow(10, Math.floor(Math.log10(buffered)));

    // Round up to nearest nice number based on magnitude
    return Math.ceil(buffered / magnitude) * magnitude;
  }, [chartSeries]);

  const colors = ["#FF7A45", "#00c0d6", "#8a63ff"];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
      //   offsetX: 0,
      //   offsetY: 0
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth:
          chartSeries?.length >= 3
            ? "100%"
            : chartSeries?.length === 2
            ? "50%"
            : "15%",
        borderRadius: 4,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ['transparent']
    // },
    xaxis: {
      categories: chartSeries?.map((s) => s?.name),
      labels: {
        style: {
          fontSize: "12px",
          colors: "#64748B",
        },
      },
      axisBorder: {
        show: true,
        color: "#666666",
        height: 1,
        // offsetX: 0,
        // offsetY: 0
      },
      axisTicks: {
        show: true,
        color: "#333",
        height: 6,
      },
      //   position: 'bottom',
      tickPlacement: "between",
    },
    yaxis: {
      min: 0,
      max: maxValue,
      tickAmount: 4,
      labels: {
        style: {
          fontSize: "12px",
          colors: "#64748B",
        },
        offsetX: -10,
      },
      axisBorder: {
        show: true,
        color: "#666666",
        width: 1,
        offsetX: 0,
      },
      axisTicks: {
        show: true,
        color: "#333",
        width: 6,
        offsetX: -5,
      },
    },
    grid: {
      borderColor: "#E2E8F0",
      strokeDashArray: 5,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      //   padding: {
      //     left: 40,
      //     right: 20
      //   }
    },
    colors: colors,
    legend: {
      show: false,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (value) {
          return value.toLocaleString();
        },
      },
    },
  };

  return (
    <div
      className="card shadow-sm"
      style={{
        backgroundColor: "#F8FAFC",
        border: "1px solid #E2E8F0",
        borderRadius: "10px",
      }}
    >
      {filteredResources?.length > 0 ? (
        <div className="card-body">
          <div className="section-title mb-0">Overall Grant Distribution</div>
          <div>
            <ReactApexChart
              options={chartOptions}
              series={chartSeries}
              type="bar"
              height={240}
            />
          </div>

          <div
            style={{
              //   border: '2px dashed #00BCD4',
              //   padding: '15px',
              //   borderRadius: '5px',
              display: "flex",
              justifyContent: "center",
              gap: "40px",
              flexWrap: "wrap",
            }}
          >
            {chartSeries.map((item, index) => (
              <div key={index} className="d-flex align-items-center">
                <span
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: colors[index],
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "10px",
                  }}
                ></span>
                <span style={{ fontSize: "12px", color: "#45556C" }}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="text-center d-flex justify-content-center align-items-center"
          style={{ height: "329px" }}
        >
          <p className="fw-bold fs-5 balance-heading-color m-0">
            {activeType === "addon"
              ? " No Add-Ons purchased for this subscription"
              : " No Base Offer purchased for this subscription"}
          </p>
        </div>
      )}
    </div>
  );
}
